import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { usePartnerDetail } from "Partner/Api/Query/usePartnerByIdQuery";
import { PartnerTabHeader } from "Partner/Components/PartnerTabHeader";
import {
	getPartnerDetailTabs,
	type PartnerDetailTabs,
} from "Partner/Pages/Detail/Tabs/Hooks/usePartnerDetailTabs";
import { PageContainer } from "Shared/Components/Container";
import { Tabs } from "Shared/Components/Tabs";
import { getTabPanelElement } from "Shared/Components/Tabs/Helpers/getTabPanelElement";
import { useNavigateTabs } from "Shared/Components/Tabs/Hooks/useNavigateTabs";
import { Box, CircularProgress } from "@mui/material";
import type { FC } from "react";
import { useParams } from "react-router";

type PartnerDetailProps = {
	currentTab: PartnerDetailTabs;
};

const partnerTabResource = Resources.base.partner.tabs;

export const PartnerDetailPage: FC<PartnerDetailProps> = ({ currentTab }) => {
	const { t } = useResource();
	const { id: paramsId } = useParams();
	const partnerId = paramsId ? Number(paramsId) : undefined;

	const { data: partner, isLoading } = usePartnerDetail(partnerId);

	const tabs = partnerId ? getPartnerDetailTabs(partnerId, t) : null;

	return (
		<>
			{!partner && isLoading && (
				<Box width="100%" display="flex" justifyContent="center" mt={5}>
					<CircularProgress />
				</Box>
			)}
			{partner && (
				<PageContainer
					title={t(partnerTabResource.title)}
					description={t(partnerTabResource.description)}
				>
					<PartnerTabHeader partner={partner} />
					<Tabs
						value={currentTab}
						tabs={tabs ?? []}
						mapItem={(tab) => getTabPanelElement(tab, partner)}
						hookFunction={useNavigateTabs}
					/>
				</PageContainer>
			)}
		</>
	);
};
